/* -------------------------------------------------------------------------- */
/*                               Tooltip styles                               */
/* -------------------------------------------------------------------------- */

@import './bq-tooltip.variables';

.bq-tooltip--panel {
  @include animation-fade-in;
  @apply pointer-events-none fixed z-[--bq-tooltip--z-index] box-border bg-[--bq-tooltip--background-color];
  @apply is-[--bq-tooltip--width] max-is-[--bq-tooltip--max-width] p-b-[--bq-tooltip--paddingY] p-i-[--bq-tooltip--paddingX];
  @apply text-[length:--bq-tooltip--font-size] leading-[--bq-tooltip--line-height] text-[color:--bq-tooltip--text-color];
  @apply rounded-[--bq-tooltip--border-radius] border-[length:--bq-tooltip--border-width] border-[color:--bq-tooltip--border-color];
  @apply shadow-[shadow:--bq-tooltip--box-shadow];
}

.bq-tooltip--arrow {
  &,
  &::before {
    @apply absolute -z-[1] bs-2 is-2;
  }

  &::before {
    @apply start-0 rotate-45 bg-[--bq-tooltip--background-color] content-empty inset-bs-0;
  }
}
